import React, { memo } from 'react';
import Popup from '../helpers/Popup';
import FormGroup from '../helpers/FormGroup';
import BaseButton from '../helpers/Button';
import LoadAnimation from '../decorators/LoadAnimation';
import { EventPopupInput } from '../Company/TradeShow/MidBlock/EventPopupInput';

const Button = LoadAnimation(BaseButton, undefined, undefined, true);

const AddTradeShowEventPopup = props => {
  const { event, onChange, onSave, onClose, canSave } = props;
  const footer = (
    <>
      <Button
        key="save"
        className="btn-primary"
        data-dismiss="modal"
        disabled={!canSave}
        onClick={onSave}
        autoFocus
      >
        Save
      </Button>
      <Button key="close" data-dismiss="modal" onClick={onClose}>
        Close
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header="Add event" id="addEventPopup">
      <div className="row">
        <FormGroup className="col-xs-4">
          <EventPopupInput
            field={event.year}
            label="Year"
            max="2022"
            min="2000"
            name="year"
            onChange={onChange}
            type="number"
          />
        </FormGroup>
        <FormGroup className="col-xs-8">
          <EventPopupInput field={event.title} label="Title" name="title" onChange={onChange} type="text" />
        </FormGroup>
      </div>
      <div className="row">
        <FormGroup className="col-xs-8">
          <EventPopupInput field={event.city} label="City" name="city" onChange={onChange} type="text" />
        </FormGroup>
        <FormGroup className="col-xs-4">
          <EventPopupInput field={event.state} label="State" name="state" onChange={onChange} type="text" />
        </FormGroup>
      </div>
      <div className="row">
        <FormGroup className="col-xs-6">
          <EventPopupInput
            field={event.startDate}
            label="Start Date"
            max={event.endDate}
            name="startDate"
            onChange={onChange}
            type="date"
          />
        </FormGroup>
        <FormGroup className="col-xs-6">
          <EventPopupInput
            field={event.endDate}
            label="End Date"
            min={event.startDate}
            name="endDate"
            onChange={onChange}
            type="date"
          />
        </FormGroup>
      </div>
    </Popup>
  );
};

export default memo(AddTradeShowEventPopup);
